module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_heading-ashinagasan-pc-17e19c2fa2a0deb40451a22be072615e.png";